import React from 'react'
import { Bar } from 'react-chartjs-2'
import '../chartSetup'

// Reusable bar chart supporting single or multiple series.
// `datasets` is an array of { label, color, data }.
const BarChart = ({ labels, datasets, height = 260 }) => {
    const isGrouped = datasets.length > 1

    const data = {
        labels,
        datasets: datasets.map((set) => ({
            label: set.label,
            data: set.data,
            backgroundColor: set.color,
            borderRadius: 0,
            barPercentage: isGrouped ? 0.8 : 0.6,
            categoryPercentage: isGrouped ? 0.75 : 0.7
        }))
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: { mode: 'index', intersect: false }
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { color: '#999a9d', font: { size: 11 } }
            },
            y: {
                beginAtZero: true,
                grid: { color: '#f0f0f0' },
                border: { display: false },
                ticks: { color: '#999a9d', font: { size: 11 } }
            }
        }
    }

    return (
        <div style={{ height }}>
            <Bar data={data} options={options} />
        </div>
    )
}

export default BarChart
